<template>
  <div v-if="!loading" class="flex flex-col">
    <router-link
      v-if="hasPermission('edit_products')"
      :to="{ name: 'productsCreateForm' }"
      class="primary-button mx-0 mt-4"
      >Crear Producto</router-link
    >

    <div class="mt-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div
          v-for="product in products"
          :key="product.id"
          class="card relative"
        >
          <router-link
            :to="{ name: 'productsDetail', params: { id: product.id } }"
          >
            <img
              :src="getImage(product)"
              alt=""
              class="rounded-t-lg w-full aspect-square object-contain object-center bg-white"
            />
          </router-link>

          <div class="w-full rounded-b-lg bg-white px-4 pt-4">
            <p class="font-medium">{{ product.name }}</p>
            <p class="font-medium text-success-500">
              {{ integerToCurrency(product.unit_price) }}
            </p>
            <p class="text-sm">{{ product.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Products",

  components: {
    Pagination,
  },

  data() {
    return {
      products: null,
      loading: false,
      defaultImage: require("@/assets/paw.png"),
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setStoreSelectedTab", "products");

    this.loadProducts();
  },

  methods: {
    integerToCurrency,

    async loadProducts() {
      this.loading = true;

      try {
        const response = await api.products.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
        ]);
        this.products = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadProducts();
    },

    getImage(product) {
      if (Array.isArray(product.images) && product.images.length) {
        const sorted = [...product.images].sort(
          (a, b) => (a.position ?? 0) - (b.position ?? 0)
        );
        if (sorted[0]?.url) return sorted[0].url;
      }

      if (!product.image_url) {
        return this.defaultImage;
      }

      return product.image_url;
    },
  },
};
</script>